export default __webpack_public_path__ + "static/thumb-landscape-5a3974e83cbac548074eebdd233e9997.jpg";